import React, { useContext, useState } from 'react'
import { AuditPromiseClient } from '@trustero/trustero-api-web/lib/audit/audit_grpc_web_pb'
import {
  ReportType,
  SaveReportRequest,
} from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { useCurrentFormAuditId } from 'src/context/FormContext/CurrentFormAuditContext'
import { useHideModal, useIsShowModal } from 'src/Modal/ModalStateContext'
import log from 'loglevel'
import { useGrpcRevalidateByMethod } from 'src/components/async'
import { useAuthorizedGrpcClient } from '../../../../adapter'
import { ModalForm, ModalFormId, ModalFormIdQueryParam } from '../../ModalForm'
import {
  StandardButton,
  StandardButtonSize,
  StandardButtonVariant,
} from '../../../Reusable/Buttons'
import { Spinner, ThrobberContext } from '../../../../Throbber'
import { ReportFileSelector } from './ReportFileSelector'
import { ReportFile } from './ReportFile'

export type AddReportFormData = {
  mime: string
  body: File | undefined
}

export const AddReportQueryParams = {
  MODAL_FORM_ID: ModalFormIdQueryParam,
  AUDIT_ID: 'auditId',
}

export const AddReportForm = (): JSX.Element => {
  const { auditId } = useCurrentFormAuditId()
  const [formData, formDataSet] = useState<AddReportFormData>({
    mime: '',
    body: undefined,
  })
  const grpcRevalidateByMethod = useGrpcRevalidateByMethod()

  const { setThrobberState } = useContext(ThrobberContext)

  const onHide = () => {
    formDataSet({
      mime: '',
      body: undefined,
    })
  }
  const show = useIsShowModal(ModalFormId.ADD_CLOSED_AUDIT_FINAL_REPORT)
  const hide = useHideModal({
    onHide,
    modalId: ModalFormId.ADD_CLOSED_AUDIT_FINAL_REPORT,
  })

  const client = useAuthorizedGrpcClient(AuditPromiseClient)

  const onSubmit: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault()

    const { mime, body } = formData
    const request = new SaveReportRequest()
      .setAuditId(auditId)
      .setType(ReportType.CLOSED_AUDIT_FINAL_PAPERS)
    if (body) {
      const bodyBytes = new Uint8Array(await new Response(body).arrayBuffer())
      request.setMime(mime).setBody(bodyBytes).setName(body?.name.trim())
    }

    // Clear state and close modal
    try {
      setThrobberState({
        isShown: true,
        Display: <Spinner color="primary" size="xl" />,
      })
      await client.saveReport(request)
      await grpcRevalidateByMethod(AuditPromiseClient.prototype.getAudits)
    } catch (err) {
      log.error(`Error saving report for auditId: ${auditId}`, err)
    } finally {
      setThrobberState({
        isShown: false,
        Display: <></>,
      })
      hide()
    }
  }

  const submit = (
    <StandardButton
      disabled={!formData.body}
      type="submit"
      id={ModalFormId.ADD_CLOSED_AUDIT_FINAL_REPORT}
      variant={StandardButtonVariant.PRIMARY}
      buttonSize={StandardButtonSize.MEDIUM}
      onClick={onSubmit}
    >
      Submit
    </StandardButton>
  )
  return (
    <ModalForm
      show={show}
      hide={hide}
      formId={ModalFormId.ADD_CLOSED_AUDIT_FINAL_REPORT}
      title="Upload Final Report"
      description="Congrats getting to the finish line! Store your final report for this audit for easy access later."
      customSubmitButton={submit}
    >
      <form
        id={ModalFormId.ADD_CLOSED_AUDIT_FINAL_REPORT}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <ReportFileSelector {...{ setFormData: formDataSet, formData }} />
        <ReportFile {...{ formData }} />
      </form>
    </ModalForm>
  )
}
